import React from 'react'
import { get } from 'lodash'
import { Box, Text, UseDisclosureProps } from '@chakra-ui/react'

import { Modal } from '@/components/shared/Modal'
import { TagForm } from './TagForm'

import { useUpdateTag } from '../mutations'
import { Tag } from '../types'
import { transformTagIntoForm } from '../utils'
import { t } from '@/lib/helpers'

type Props = {
  disclosure: UseDisclosureProps
  initialData?: Tag
}

export const EditTagFormModal = (props: Props) => {
  const { disclosure, initialData } = props

  const { isOpen, onClose } = disclosure

  const { mutate: updateTag, isLoading } = useUpdateTag()

  return (
    <Modal isOpen={isOpen} onClose={onClose} withCloseButton>
      <Box sx={{ p: '32px', pb: '40px' }}>
        <Text textStyle="modalHeader" sx={{ mb: '20px' }} isTruncated>
          {t('views.admin.tags.edit.title', {
            title: get(initialData, 'name'),
          })}
        </Text>

        <TagForm
          isLoading={isLoading}
          defaultValues={transformTagIntoForm(initialData)}
          onSubmitForm={(data) => {
            updateTag(
              { form: data, id: get(initialData, 'id') },
              { onSuccess: onClose },
            )
          }}
        />
      </Box>
    </Modal>
  )
}
